import {GridItem} from "../codegen/graphql";

const ASSET_WIDTH = 36;  // 28px SVG + 8px padding (px: 0.5 each side)
const ASSET_GAP = 16;    // gap={2} = 16px
const BOX_PADDING = 10;  // p="5px" * 2 sides
const GRID_MARGIN = 10;  // react-grid-layout default margin
const ZOOM_BUFFER = 100; // extra space to allow ~125% browser zoom

export const getGridItemDimensions = (
    gridItem: GridItem | null,
    totalItems: number = 0,
    containerWidth: number = 0,
    cols: number = 12,
): {w: number, h: number} => {
    const configWidth = gridItem?.config?.w
    const configHeight = gridItem?.config?.h

    let h = configHeight || 1;
    if ((!configHeight || configHeight === 0) && totalItems > 0) {
        h = 1;
    }

    // Use saved config width if available
    if (configWidth && configWidth > 0) {
        return { w: configWidth, h }
    }

    // Calculate pixel width needed for all assets
    const assetsWidth = totalItems > 0
        ? totalItems * ASSET_WIDTH + (totalItems - 1) * ASSET_GAP + BOX_PADDING
        : BOX_PADDING;

    // If container width is known, calculate precisely
    if (containerWidth > 0) {
        const colWidth = (containerWidth - GRID_MARGIN * (cols + 1)) / cols;
        const getItemWidth = (w: number) => colWidth * w + GRID_MARGIN * (w - 1);

        let w = 1;
        while (getItemWidth(w) < assetsWidth && w < cols) {
            w++;
        }

        // If remaining space < 100px, add 1 more unit for zoom buffer
        if (getItemWidth(w) - assetsWidth < ZOOM_BUFFER && w < cols) {
            w++;
        }

        return { w, h }
    }

    // Fallback when container width is not yet known
    let w = 1;
    if (totalItems > 1) w = 2;
    if (totalItems > 3) w = 3;

    return { w, h }
}
